import { render } from "./FahrzeugBearbeiten.vue?vue&type=template&id=2fb70304"
import script from "./FahrzeugBearbeiten.vue?vue&type=script&lang=js"
export * from "./FahrzeugBearbeiten.vue?vue&type=script&lang=js"

import "./FahrzeugBearbeiten.vue?vue&type=style&index=0&id=2fb70304&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__